import { NavHashLink as NavLink } from "react-router-hash-link";
import datas from "../../../datas/rubriques.json";
const { REACT_APP_BASE_METATITLE2 } = process.env;
import CieModal from '../CieModal/CieModal';

const { REACT_APP_PUBLIC_URL } = process.env;
const Footer = () => {
  const date = new Date();

    return (

        <div id = "footer" >
          <div className = "columns" >
            <div className="column footer__copyright is-offset-8-desktop is-4-desktop is-12 is-justify-content-center is-align-items-flex-end" >
            <ul className="nav is-inline" >
              <li className="nav-item">
                <CieModal showNext id="modalCredits"

                  open="<a href='#' class='nav-link'>Mentions légales</a>"
                  content={process.env.REACT_APP_MENTIONS}
                />
              </li>
              {
                    datas &&
                    datas.filter(i => i.footerMenu === true).map((item, index) => {
                        const {
                            title,
                            slug,
                            subRubriques,
                            url,
                            isMobileOnly,
                        } = item;
                        return ( <li key = { index }
                            className = "nav-item" >
                            <a className = "nav-link"
                            href = { `${REACT_APP_PUBLIC_URL}${url}` } target="_blank"> { title } </a> </li>
                        );
                    })
              }

              <li className="nav-item copyright"><a href="https://elogie-siemp.paris" target="_blank" > ©{date.getFullYear()} {REACT_APP_BASE_METATITLE2} </a></li>

              </ul>

          </div>
        </div>
      </div>

    );
};
export default Footer;
